export function ResponseError(error) {
    this.name = `ResponseError`;
    this.message = '';
    this.stack = (new Error()).stack;
}

ResponseError.prototype = Object.create(Error.prototype);
ResponseError.prototype.constructor = ResponseError;